import script from "./ProductsCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsCheck.vue?vue&type=script&lang=ts&setup=true"

import "./ProductsCheck.vue?vue&type=style&index=0&id=3471fa4d&scoped=true&lang=css"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3471fa4d"]])

export default __exports__